import React from 'react';
import BadgeBase, { TBadge } from './BadgeBase';
import { BadgeSignals } from '../../types/TEBadgeSignal';

const Error = (props: Omit<TBadge, 'signal'>) => <BadgeBase {...props} signal={BadgeSignals.Error} />;

export default Error;
